import { combineReducers } from 'redux';
import { auth } from './auth/auth';
import { adminStore } from './admin/admin';
import { userStore } from './user/user';
import { commonStore } from './common/common';
import { imagesStore } from './images/images';
import { domainsStore } from './domainPage/domainPage';
import { qc_frStore } from './qc_fr/qc_fr';
import { searchStore } from './search/search';
import { importStore } from './import/import';
import { exportFile } from './export/exportFile';
import { blackList } from './blackList/blackList';
import { saveChanges } from './saveChanges/saveChanges';
import { navigationStore } from './navigation/navigation';
import { sightingsStore } from './sightings/sightings';
import { chatStore } from './chat/chat';

export default combineReducers({
  auth,
  adminStore,
  userStore,
  commonStore,
  imagesStore,
  domainsStore,
  qc_frStore,
  searchStore,
  importStore,
  exportFile,
  blackList,
  saveChanges,
  navigationStore,
  sightingsStore,
  chatStore
});
